import {
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { asList2ho2pewtsfvv as asList } from './_ArraysJs.mjs';
import { filterNotNullhujglslymx1l as filterNotNull } from './_Arrays.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { listOfvhqybd2zx248 as listOf } from './collectionJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../comparisons/Comparisons.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../js/metadataUtils.mjs';
import { KtList3hktaavzmj137 as KtList } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_lastIndex(_this__u8e3s4) {
  return _this__u8e3s4.get_size_woubt6_k$() - 1 | 0;
}
function throwIndexOverflow() {
  throw ArithmeticException().new_kotlin_ArithmeticException_y2sjkx_k$('Index overflow has happened.');
}
function collectionToArrayCommonImpl(collection) {
  if (collection.isEmpty_y1axqb_k$()) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  // Inline function 'kotlin.arrayOfNulls' call
  var size = collection.get_size_woubt6_k$();
  var destination = Array(size);
  var iterator = collection.iterator_jk1svi_k$();
  var index = 0;
  while (iterator.hasNext_bitz1p_k$()) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    destination[_unary__edvuaz] = iterator.next_20eer_k$();
  }
  return destination;
}
function listOf_0(elements) {
  return elements.length > 0 ? asList(elements) : emptyList();
}
function listOfNotNull(elements) {
  return filterNotNull(elements);
}
function emptyList() {
  return EmptyList_instance;
}
function get_indices(_this__u8e3s4) {
  return numberRangeToNumber(0, _this__u8e3s4.get_size_woubt6_k$() - 1 | 0);
}
function arrayListOf(elements) {
  var tmp;
  if (elements.length === 0) {
    tmp = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  } else {
    // Inline function 'kotlin.collections.asArrayList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = ArrayList().new_kotlin_collections_ArrayList_qfbsh5_k$(elements);
  }
  return tmp;
}
function listOfNotNull_0(element) {
  return !(element == null) ? listOf(element) : emptyList();
}
function mutableListOf(elements) {
  var tmp;
  if (elements.length === 0) {
    tmp = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  } else {
    // Inline function 'kotlin.collections.asArrayList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = ArrayList().new_kotlin_collections_ArrayList_qfbsh5_k$(elements);
  }
  return tmp;
}
function binarySearch(_this__u8e3s4, element, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.get_size_woubt6_k$() : toIndex;
  rangeCheck(_this__u8e3s4.get_size_woubt6_k$(), fromIndex, toIndex);
  var low = fromIndex;
  var high = toIndex - 1 | 0;
  while (low <= high) {
    var mid = (low + high | 0) >>> 1 | 0;
    var midVal = _this__u8e3s4.get_c1px32_k$(mid);
    var cmp = compareValues(midVal, element);
    if (cmp < 0)
      low = mid + 1 | 0;
    else if (cmp > 0)
      high = mid - 1 | 0;
    else
      return mid;
  }
  return -(low + 1 | 0) | 0;
}
var EmptyIteratorClass;
function EmptyIterator() {
  if (EmptyIteratorClass === VOID) {
    class $ {
      hasNext_bitz1p_k$() {
        return false;
      }
      hasPrevious_qh0629_k$() {
        return false;
      }
      next_20eer_k$() {
        throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
      }
      previous_l2dfd5_k$() {
        throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
      }
    }
    initMetadataForObject($, 'EmptyIterator');
    EmptyIteratorClass = $;
  }
  return EmptyIteratorClass;
}
var EmptyIterator_instance;
function EmptyIterator_getInstance() {
  return EmptyIterator_instance;
}
function optimizeReadOnlyList(_this__u8e3s4) {
  switch (_this__u8e3s4.get_size_woubt6_k$()) {
    case 0:
      return emptyList();
    case 1:
      return listOf(_this__u8e3s4.get_c1px32_k$(0));
    default:
      return _this__u8e3s4;
  }
}
var EmptyListClass;
function EmptyList() {
  if (EmptyListClass === VOID) {
    class $ {
      constructor() {
        this.serialVersionUID_1 = -7390468764508069838n;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtList()) : false) {
          tmp = other.isEmpty_y1axqb_k$();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 1;
      }
      toString() {
        return '[]';
      }
      get_size_woubt6_k$() {
        return 0;
      }
      isEmpty_y1axqb_k$() {
        return true;
      }
      contains_a7ux40_k$(element) {
        return false;
      }
      contains_aljjnj_k$(element) {
        if (!false)
          return false;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.contains_a7ux40_k$(tmp);
      }
      get_c1px32_k$(index) {
        throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$("Empty list doesn't contain element at index " + index + '.');
      }
      indexOf_31ms1i_k$(element) {
        return -1;
      }
      indexOf_si1fv9_k$(element) {
        if (!false)
          return -1;
        var tmp;
        if (false) {
          tmp = element;
        } else {
          tmp = THROW_CCE();
        }
        return this.indexOf_31ms1i_k$(tmp);
      }
      iterator_jk1svi_k$() {
        return EmptyIterator_instance;
      }
      listIterator_70e65o_k$(index) {
        if (!(index === 0))
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Index: ' + index);
        return EmptyIterator_instance;
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        if (fromIndex === 0 && toIndex === 0)
          return this;
        throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
      }
    }
    initMetadataForObject($, 'EmptyList', VOID, VOID, [KtList(), RandomAccess()]);
    EmptyListClass = $;
  }
  return EmptyListClass;
}
var EmptyList_instance;
function EmptyList_getInstance() {
  return EmptyList_instance;
}
function binarySearch_0(_this__u8e3s4, fromIndex, toIndex, comparison) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.get_size_woubt6_k$() : toIndex;
  rangeCheck(_this__u8e3s4.get_size_woubt6_k$(), fromIndex, toIndex);
  var low = fromIndex;
  var high = toIndex - 1 | 0;
  while (low <= high) {
    var mid = (low + high | 0) >>> 1 | 0;
    var midVal = _this__u8e3s4.get_c1px32_k$(mid);
    var cmp = comparison(midVal);
    if (cmp < 0)
      low = mid + 1 | 0;
    else if (cmp > 0)
      high = mid - 1 | 0;
    else
      return mid;
  }
  return -(low + 1 | 0) | 0;
}
function rangeCheck(size, fromIndex, toIndex) {
  if (fromIndex > toIndex)
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
  else if (fromIndex < 0)
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('fromIndex (' + fromIndex + ') is less than zero.');
  else if (toIndex > size)
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('toIndex (' + toIndex + ') is greater than size (' + size + ').');
}
function throwCountOverflow() {
  throw ArithmeticException().new_kotlin_ArithmeticException_y2sjkx_k$('Count overflow has happened.');
}
//region block: init
EmptyIterator_instance = new (EmptyIterator())();
EmptyList_instance = new (EmptyList())();
//endregion
//region block: exports
export {
  EmptyIterator_instance as EmptyIterator_instancex3sopkoseugu,
  EmptyList_instance as EmptyList_instanceq4z55tiumr5b,
  arrayListOf as arrayListOf1fz8nib0ncbow,
  binarySearch as binarySearch1nmlzx9onl5pm,
  binarySearch_0 as binarySearchyyczvdessj07,
  collectionToArrayCommonImpl as collectionToArrayCommonImplq0mfhcp9jn08,
  emptyList as emptyList1g2z5xcrvp2zy,
  get_indices as get_indices3txodfl5wuu5j,
  get_lastIndex as get_lastIndex1yw0x4k50k51w,
  listOfNotNull_0 as listOfNotNull1v4ggfackvuny,
  listOfNotNull as listOfNotNull2woi2boe01ub4,
  listOf_0 as listOf1jh22dvmctj1r,
  mutableListOf as mutableListOf6oorvk2mtdmp,
  optimizeReadOnlyList as optimizeReadOnlyList2kolyxeo5m6k3,
  throwCountOverflow as throwCountOverflow18of2v929seka,
  throwIndexOverflow as throwIndexOverflow28kwzhaoae5ib,
};
//endregion

//# sourceMappingURL=CollectionsKt.mjs.map
